module.exports = __webpack_public_path__ + "static/Unify-3-dark-a29538cd275e8c974580c3302c9d3687.svg";